export default "<div class=\"titulo\" (dblclick)=\"showAlert()\">\n  <h1>\n    {{ titulo }}\n  </h1>\n  <hr>\n</div>\n";